export const state = {
    places: [],
    transitions: [],
    placesUpdatedAt: null,
    placesForceUpdate: false,
    transitionsUpdatedAt: null,
    transitionsForceUpdate: false
};

export const reducer = {
    setPlaces(state, action) {
        if ('places' in (state || {})) {
            state.places = action?.payload;
        }
        if ('placesUpdatedAt' in (state || {})) {
            state.placesUpdatedAt = new Date();
        }
        if ('placesForceUpdate' in (state || {})) {
            state.placesForceUpdate = false;
        }
    },
    clearPlaces(state) {
        if ('places' in (state || {})) {
            state.places = [];
        }
    },
    setTransitions(state, action) {
        if ('transitions' in (state || {})) {
            state.transitions = action?.payload;
        }
        if ('transitionsUpdatedAt' in (state || {})) {
            state.transitionsUpdatedAt = new Date();
        }
        if ('transitionsForceUpdate' in (state || {})) {
            state.transitionsForceUpdate = false;
        }
    },
    clearTransitions(state) {
        if ('transitions' in (state || {})) {
            state.transitions = [];
        }
    }
};

// eslint-disable-next-line no-unused-vars
export const gridActions = (row, permissionData, onClickActions) => [];
